/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useGetAccountsQuery } from "~/generated/graphql";
import { SidebarSelector } from "~/components/SidebarSelector";
import { UniversalWrap } from "~/components/Utils";
import { isNotNil } from "~/tools";
import { getCloudAccounts } from "../utils";

type Props = {
  onSubmit: (value: string) => void;
  onClose: () => void;
  isOpen: boolean;
  excludeItems?: string[];
};

export function CloudAccountSelector({
  onSubmit,
  onClose,
  isOpen,
  excludeItems = [],
}: Props) {
  const { data, loading, error } = useGetAccountsQuery();
  const accounts = data?.accounts ? data.accounts.filter(isNotNil) : [];

  const options = getCloudAccounts(accounts).filter(
    (option) => !excludeItems.includes(option.value)
  );

  return (
    <UniversalWrap
      errorProps={{ error }}
      loaderProps={{
        loading: isOpen && loading,
        inContent: true,
      }}
    >
      <SidebarSelector
        hasIcon
        hasSubtitle
        limit={20}
        isOpen={isOpen}
        options={options}
        name="Cloud Account"
        onClick={onClose}
        onSubmit={onSubmit}
      />
    </UniversalWrap>
  );
}
